(function () {
    'use strict';

    angular
        .module('core.services')
        .service('UnitService', UnitService)

    /** @ngInject */
    function UnitService(HttpService) {
        const UnitService = {
            getByParameters: getByParameters,
            get: get,
            getResumed: getResumed,
            getFromIdeologica: getFromIdeologica,
            getAllResumed: getAllResumed,
            getAllClosedResumed: getAllClosedResumed,
            getHours: getHours,
            getDocumentTypes: getDocumentTypes,
            getStatus: getStatus,
            getTypes: getTypes,
            getPdvSystems: getPdvSystems,
            getStoreSystems: getStoreSystems,
            post: post,
            postImage: postImage,
            postPromotion: postPromotion,
            postVideo: postVideo,
            postWorkingTime: postWorkingTime,
            put: put,
            refreshUnitFromIdeologica: refreshUnitFromIdeologica,
            putImage: putImage,
            putPromotion: putPromotion,
            putVideo: putVideo,
            putWorkingTime: putWorkingTime,
            delete: deleteUnit,
            deleteImage: deleteImage,
            deletePromotion: deletePromotion,
            deleteVideo: deleteVideo,
            getPromotions: getPromotions,
            getVideos: getVideos,
            reopenUnit: reopenUnit
        }

        return UnitService;

        function getByParameters(params) {
            return HttpService.get('/units', {
                params
            });
        }

        function get(unitId) {
            return HttpService.get(`/units/${unitId}`);
        }

        function getResumed(unitId) {
            return HttpService.get(`/units/resumed/${unitId}`);
        }

        function getFromIdeologica(unitExternalCode) {
            return HttpService.get(`/units/ideologica/${unitExternalCode}`);
        }

        function getAllResumed() {
            return HttpService.get('/units/resumed-for-listing');
        }

        function getAllClosedResumed() {
            return HttpService.get('/units/closed/resumed-for-listing');
        }

        function getDocumentTypes() {
            return HttpService.get('/units/documents/types');
        }

        function getStatus() {
            return HttpService.get('/units/status');
        }

        function getHours() {
            return HttpService.get('/unit-operations/hours');
        }

        function getTypes() {
            return HttpService.get('/unit-types/all')
        }

        function getPdvSystems() {
            return HttpService.get('/pdv-systems');
        }

        function getStoreSystems() {
            return HttpService.get('/store-systems');
        }

        function post(unitData) {
            return HttpService.post('/units', unitData);
        }

        function postImage(unitImageData) {
            return HttpService.post('/units/images', unitImageData);
        }

        function postPromotion(promotionData) {
            return HttpService.post('/units/promotions', promotionData);
        }

        function postVideo(videoData) {
            return HttpService.post('/units/videos', videoData);
        }

        function postWorkingTime(unitOperationData) {
            return HttpService.post('/unit-operations', unitOperationData);
        }

        function put(unitData) {
            return HttpService.put('/units', unitData);
        }

        function refreshUnitFromIdeologica(unitExternalCode = null) {
            let url = 'refresh';

            if (unitExternalCode)
                url = `${url}/${unitExternalCode}`

            return HttpService.put(`/units/${url}`);
        }

        function putImage(unitImageData) {
            return HttpService.put('/units/images', unitImageData);
        }

        function putPromotion(promotionData) {
            return HttpService.put('/units/promotions', promotionData);
        }

        function putVideo(videoData) {
            return HttpService.put('/units/videos', videoData);
        }

        function putWorkingTime(unitOperationData) {
            return HttpService.put('/unit-operations', unitOperationData);
        }

        function deleteUnit(unitId) {
            return HttpService.delete(`/units/${unitId}`);
        }

        function deleteImage(unitImageId) {
            return HttpService.delete(`/units/images/${unitImageId}`);
        }

        function deletePromotion(promotionId) {
            return HttpService.delete(`/units/promotions/${promotionId}`);
        }

        function deleteVideo(videoId) {
            return HttpService.delete(`/units/videos/${videoId}`);
        }

        function getPromotions(unitId) {
            return HttpService.get(`/units/${unitId}/promotions`);
        }

        function getVideos(unitId) {
            return HttpService.get(`/units/${unitId}/videos`);
        }

        function reopenUnit(unitData) {
            return HttpService.post('/units/recreate', unitData)
        }
    }
}());
